import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from 'styles/util';

import Box from '@material-ui/core/Box';
import Lightbox from 'react-image-lightbox';

import 'react-image-lightbox/style.css';

const ImageThumbnails = ({ images, maxSize = 64 }) => {
    const useStyles = makeStyles(({ theme }) => ({
        thumbnails: {
            display: 'flex',
            gap: theme.spacing(2),
            alignItems: 'center'
        },
        thumbnail: {
            maxWidth: `${maxSize}px`,
            maxHeight: `${maxSize}px`,
            cursor: 'pointer'
        }
    }));
    const classes = useStyles();
    const [lightboxOpen, setLightboxOpen] = useState(false);
    const [lightboxIndex, setLightboxIndex] = useState(0);

    if(!images?.length) {
        return null;
    }

    return (
        <Box className={classes.thumbnails}>
            {
                images.map((image, i) => (
                    <img
                        key={i}
                        src={image.mediaUrl}
                        className={classes.thumbnail}
                        onClick={() => {
                            setLightboxIndex(i);
                            setLightboxOpen(true);
                        }}
                    />
                ))
            }
            {
                lightboxOpen &&
                (
                    <Lightbox
                        reactModalStyle={{ overlay: { zIndex: 100000 } }}
                        mainSrc={images[lightboxIndex].mediaUrl}
                        nextSrc={images.length > 1 ? images[((lightboxIndex + 1) % images.length)].mediaUrl : undefined}
                        prevSrc={images.length > 1 ? images[((lightboxIndex + images.length - 1) % images.length)].mediaUrl : undefined}
                        onCloseRequest={() => setLightboxOpen(false)}
                        onMovePrevRequest={() =>
                            setLightboxIndex((lightboxIndex + images.length - 1) % images.length)
                        }
                        onMoveNextRequest={() =>
                            setLightboxIndex((lightboxIndex + 1) % images.length)
                        }
                    />
                )
            }
        </Box>
    );
};

ImageThumbnails.propTypes = {
    images: PropTypes.array,
    maxSize: PropTypes.number
};

export default ImageThumbnails;
